(function () {
  function track(eventName) {
    if (typeof window.fbq !== 'function') return
    window.fbq('track', eventName)
  }

  function bindLeadForms() {
    document.querySelectorAll('.vera-signup-form').forEach(function (form) {
      if (form.dataset.veraMetaLeadBound === '1') return
      form.dataset.veraMetaLeadBound = '1'
      form.addEventListener('submit', function () {
        track('Lead')
      })
    })
  }

  if (window.__veraMetaContact) {
    track('Contact')
    window.__veraMetaContact = false
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLeadForms)
  } else {
    bindLeadForms()
  }
})()
